import { Component, Input, Output, EventEmitter } from "@angular/core";
import { FormControl } from "@angular/forms";
import { UtilityService } from "services";

@Component({
  selector: "app-select-field",
  templateUrl: "./global.select.component.html",
})
export class GlobalSelectComponent {
  @Input() label: string;
  @Input() tooltip: string;
  @Input() multiple;
  @Input() disabled;
  @Input() defaultOption = true;
  @Input() options: Array<any>;
  @Input() valueKey: string;
  @Input() optionKey: string;
  @Input() hint: string;
  @Input() control: FormControl;
  @Output() modelChange = new EventEmitter<any>();

  constructor(private util: UtilityService) {}

  isRequired() {
    return this.util.isRequired(this.control);
  }
  emitChange(event) {
    this.modelChange.emit(event);
  }
}
